import React from 'react'
import { About, ContactUs, Hero, Services, Operation, Gallery, Testimonials, MeetOurTeam } from '../../components'

import './home.css'

const Home = () => {
  return (
    <>
      <div className='home-wrapper'>
        <Hero />
        <About />
        <Services />
        <Operation />
        <Gallery />
        <MeetOurTeam />
        <Testimonials />
        <ContactUs />
      </div>
    </>
  )
}

export default Home